// This file was auto-generated by __GENERATE_CHAIN_PRESETS__.js. Do not edit manually.

import { polygon as _polygon } from 'viem/chains'
import { createCommon } from '../createCommon.js'

/**
 * Creates a common configuration for the polygon chain.
 * @type {import('../Common.js').Common}
 * @description
 * Chain ID: 137
 * Chain Name: Polygon
 * Default Block Explorer: https://polygonscan.com
 * Default RPC URL: https://polygon-rpc.com
 * @example
 * import { createMemoryClient } from 'tevm'
 * import { polygon } from 'tevm/common'
 * import { http } from 'tevm'
 *
 * const client = createMemoryClient({
 *   common: polygon,
 *   fork: {
 *     transport: http({ url: 'https://example.com' })({})
 *   },
 * })
 */
export const polygon = createCommon({
	..._polygon,
	loggingLevel: 'warn',
	eips: [],
	hardfork: 'prague',
})
